import * as ReactGA from 'react-ga';
import { client } from 'src';
import { GET_LOGGED_USER } from '../component/shared';

export const FilterCategoryType = {
    AUTHOR: 'AUTOR',
    BISAC: 'BISAC',
    CATEGORY: 'CATEGORIA',
    DATE: 'DATA',
    ECONOMIC_GROUP: 'GRUPO ECONOMICO',
    PRODUCT: 'PRODUTO',
    PROVIDER: 'FABRICANTE',
    STAMP: 'SELO',
    STORE: 'LOJA',
    UF: 'UF'
}

export const MetricIndex = {
    DOWNLOAD: 1,
    FILTER: 2
}

export class GoogleAnalytics {
    public fireTracking(email: string) {
        if (email) {
            // Send email as userId to analytics
            ReactGA.initialize(
                'UA-124749312-1', 
                {
                    debug: true,
                    gaOptions: { userId: email }
                }
            );
            // Send email as dimension1 (Custom Dimension) to analytics
            ReactGA.set({'dimension1': email});
            
            ReactGA.pageview(window.location.pathname);
        }
    }

    public async fireEventTracking(categoryParam:string, actionParam:string, 
        labelParam:string, nonInteractionParam:boolean, metricName:string) {
        const email = await this.getLoggedEmail();
        // Send email as userId to analytics
        ReactGA.initialize(
            'UA-124749312-1', 
            {
                debug: true,
                gaOptions: { userId: email }
            }
        );
        // Send email as dimension1 (Custom Dimension) to analytics
        ReactGA.set({'dimension1': email});
        ReactGA.set({metricName: 1});
        ReactGA.event({
            action: actionParam,
            category: categoryParam,
            label: labelParam,
            nonInteraction: nonInteractionParam
        });
    }

    public async getLoggedEmail() {
        return await client.query({query: GET_LOGGED_USER}).then((data:any) => {
            if (data && data.data && data.data.user) {
                return data.data.user.email;
            } else {
                return null;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/GoogleAnalytics.tsx